import { Controller } from '@hotwired/stimulus'
import Sortable from 'sortablejs'

export default class extends Controller {
  connect () {
    this.sortable = new Sortable(this.element, {
      onEnd: ({ item, newIndex }) => { this.dragEnd(item, newIndex) },
    })
  }

  disconnect () {
    this.sortable.destroy()
    this.sortable = undefined
  }

  dragEnd (item, newIndex) {
    this.element.querySelectorAll('label.order').forEach((e, index) => (e.innerHTML = '#' + index))
    this.element.querySelectorAll('input.order').forEach((e, index) => (e.value = index))
  }
}
